import { TemplateElement, html, defineElement, optionalAttribute } from '@webtides/element-js';
import '../../../icon/icon.js';

/**
 * @property {string} label
 * @property {string} description
 * @property {string} src
 * @property {string} assetType
 * @property {string} trackingLabel
 * @property {'' | 'compact'} variant
 */
export default class DownloadCard extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }

    properties() {
        return {
            label: '',
            description: '',
            src: '',
            assetType: '',
            trackingLabel: '',
            variant: '',
        };
    }

    _downloadLink() {
        return html`
            <a
                href="${this.src}"
                class="stretched-link"
                data-tracking='{"event":"generic","category":"downloads","action":"${this.assetType}","label":"${this
                    .label}"}'
                ${optionalAttribute(this.trackingLabel, 'tracking-label', this.trackingLabel)}
                element="download card"
            >
                <mb-icon name="app--download" class="size-24"></mb-icon>
            </a>
        `;
    }

    template() {
        if (this.variant === 'compact') {
            return html`
                <div class="relative flex items-center gap-[16px] rounded-[8px] bg-primary-subtle1 p-[16px]">
                    <div class="grow fix-body3 text-green-medium">${this.label}</div>
                    <slot>
                        <div class="flex shrink-0 items-center gap-[16px]">
                            <div
                                class="flex h-[24px] items-center whitespace-nowrap rounded-[4px] bg-primary-subtle3 px-[12px] fix-body3-medium text-green-medium"
                            >
                                ${this.assetType}
                            </div>
                            ${this._downloadLink()}
                        </div>
                    </slot>
                </div>
            `;
        }

        //TODO button - hover effect?!
        return html`
            <div class="download-card-container relative py-16 md:px-16">
                <div class="flex flex-col md:flex-row gap-16 md:justify-between md:items-center">
                    <div class="flex flex-col gap-4">
                        <div class="text-green-medium">${this.label}</div>
                        <div class="text-green-light">${this.description}</div>
                    </div>
                    <slot>
                        <div class="flex flex-row gap-16 items-center">
                            <div
                                class="text-sm font-medium text-green-medium tracking-[.01em] py-[4px] px-12 rounded-[4px] whitespace-nowrap bg-green-light40"
                            >
                                ${this.assetType}
                            </div>
                            ${this._downloadLink()}
                        </div>
                    </slot>
                </div>
            </div>
        `;
    }
}

defineElement('mb-download-card', DownloadCard);
